import React, { useMemo, useEffect, useRef } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import { observer } from 'mobx-react-lite';
import noop from 'lodash/noop';
import CardCommand from './CardCommand';
import { ViewMode } from './enum';
import Typography from '../typography';
import Output from '../output';
function getStyle(provided, style) {
    if (!style) {
        return provided.draggableProps.style;
    }
    return {
        ...provided.draggableProps.style,
        ...style,
    };
}
// Previously this extended React.Component
// That was a good thing, because using React.PureComponent can hide
// issues with the selectors. However, moving it over does can considerable
// performance improvements when reordering big lists (400ms => 200ms)
// Need to be super sure we are not relying on PureComponent here for
// things we should be doing in the selector as we do not know if consumers
// will be using PureComponent
const QuoteItem = function QuoteItem(props) {
    const { quote, isDragging, provided, style, index, prefixCls, viewProps, command, renderCommand = ({ command }) => command, dataSet, displayFields: columns, commandsLimit, } = props;
    const displayFields = useMemo(() => viewProps.displayFields, [viewProps.displayFields]);
    const firstDisplayFields = useMemo(() => columns.find(df => df.name === displayFields[0]), [columns]);
    const extraRef = useRef(null);
    useEffect(() => {
        const observer = new ResizeObserver(entries => {
            for (const entry of entries) {
                // 更新高度
                dataSet.setState('__HEADHEIGHT__', entry.contentRect.height);
            }
        });
        if (extraRef.current) {
            observer.observe(extraRef.current);
        }
        return () => {
            observer.disconnect();
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", Object.assign({ className: `${prefixCls}-quote-container`, 
            // isDragging={isDragging}
            // isGroupedOver={isGroupedOver}
            // isClone={isClone}
            ref: provided.innerRef }, provided.draggableProps, provided.dragHandleProps, { style: getStyle(provided, style), "data-is-dragging": isDragging, "data-testid": quote.id, "data-index": index }),
            React.createElement("div", { className: `${prefixCls}-quote-head-wrapper`, ref: extraRef },
                displayFields && displayFields.length ?
                    (React.createElement("p", null,
                        React.createElement(Typography.Paragraph, { ellipsis: { rows: 2, tooltip: React.createElement(Output, { name: displayFields[0], record: quote, renderer: firstDisplayFields ? firstDisplayFields.renderer : noop }) }, record: quote, name: displayFields[0], renderer: firstDisplayFields ? firstDisplayFields.renderer : noop })))
                    : React.createElement("span", { className: `${prefixCls}-quote-content-label` }, "\u8BF7\u914D\u7F6E\u663E\u793A\u5B57\u6BB5"),
                React.createElement(CardCommand, { command: command, viewMode: ViewMode.kanban, dataSet: dataSet, record: quote, renderCommand: renderCommand, prefixCls: prefixCls, commandsLimit: commandsLimit })),
            React.createElement("div", { className: `${prefixCls}-quote-content` }, displayFields ? displayFields.map(fieldName => (React.createElement("div", { key: `${fieldName}-item`, className: `${prefixCls}-quote-content-item` },
                React.createElement("span", { className: `${prefixCls}-quote-content-label`, hidden: !viewProps.showLabel }, quote.getField(fieldName).get('label')),
                React.createElement(Typography.Text, { ellipsis: { tooltip: true }, record: quote, name: fieldName, renderer: columns.find(df => df.name === fieldName) ? columns.find(df => df.name === fieldName).renderer : noop })))) : null))));
};
QuoteItem.displayName = 'QuoteItem';
export default observer(QuoteItem);
